const actions = {
  SET_STATE: 'sport/SET_STATE',
  REFRESH_ERRORS: 'sport/REFRESH_ERRORS',
  ALL: 'sport/ALL',
  FETCH_ALL: 'sport/FETCH_ALL',
  DETAILS: 'sport/DETAILS',
  ADD: 'sport/ADD',
  EDIT: 'sport/EDIT',
  REMOVE: 'sport/REMOVE'
};

export default actions
